import script from "./sf-input.vue?vue&type=script&setup=true&lang=ts&generic=MV"
export * from "./sf-input.vue?vue&type=script&setup=true&lang=ts&generic=MV"

import "./sf-input.vue?vue&type=style&index=0&id=a5db410e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5db410e"]])

export default __exports__